import { isPlatformServer } from '@angular/common';
import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { ScreenSizes } from '../../classes/screen-sizes.class';

@Directive({
  selector: '[onlyForScreens]',
  standalone: true,
})
export class ResizeDirective implements OnInit, OnDestroy {
  // listenFunc will hold the function returned by "renderer.listen"
  listenFunc: () => void;

  @Input('onlyForScreens') configWidths: string[];

  private renderer = inject(Renderer2);
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private platformId = inject(PLATFORM_ID);

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      this.doDisplayElement();
      this.addHideClasses();
      return;
    }
    this.displayElement();
    this.renderer.listen('window', 'resize', () => this.displayElement());
  }

  addHideClasses() {
    const element = this.viewContainer.get(0)['rootNodes'][0] as HTMLElement;
    if (!(element instanceof HTMLElement)) {
      return console.error('Using *onlyForScreens on an element on something that is not an HMTLElement');
    }
    // this.renderer.addClass(element, 'auto-hide');
    if (!this.configWidths.includes('mobile')) this.renderer.addClass(element, 'hide-on-mobile');
    if (!this.configWidths.includes('tablet')) this.renderer.addClass(element, 'hide-on-tablet');
    if (!this.configWidths.includes('desktop')) this.renderer.addClass(element, 'hide-on-desktop');
  }

  displayElement() {
    if (this.isValidSize()) this.doDisplayElement();
    else this.viewContainer.clear();
  }

  private doDisplayElement() {
    if (!this.viewContainer.get(0)) this.viewContainer.createEmbeddedView(this.templateRef);
  }

  isValidSize() {
    return !!this.configWidths.find(width => ScreenSizes.screenSize() === width);
  }

  ngOnDestroy() {
    this.listenFunc?.();
  }
}
